import { Button, Card, Descriptions, Flex, Table } from "antd";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";

import { ArrowLeftOutlined } from "@ant-design/icons";

import { useGetOneStationeryPeriod } from "../../query/HrmQuery";
import NotFound from "../NotFound/NotFound";

const HrmStationeryRequest = () => {
  const { alias } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useGetOneStationeryPeriod(Number(alias));

  if (!alias) return <NotFound />;
  return (
    <div className="flex-1 p-4 overflow-auto h-full">
      <Flex vertical gap="middle" className="w-full">
        <Flex align="center" justify="space-between" wrap="wrap" gap="small">
          <Button
            type="default"
            size="large"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          >
            Quay lại
          </Button>
        </Flex>
        <Card
          loading={isLoading}
          title="Thông tin kỳ văn phòng phẩm"
          className="shadow-sm border-gray-100 rounded-lg"
        >
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Tên kỳ VPP">
              {data?.name}
            </Descriptions.Item>
            <Descriptions.Item label="Thời gian">
              {dayjs(data?.startDate).format("DD/MM/YYYY HH:mm")} -{" "}
              {dayjs(data?.endDate).format("DD/MM/YYYY HH:mm")}
            </Descriptions.Item>
          </Descriptions>
        </Card>

        <Card
          title="Danh sách yêu cầu của nhân viên"
          className="shadow-sm border-gray-100 rounded-lg"
        >
          <Table
            rowKey="id"
            dataSource={data?.requests || []}
            loading={isLoading}
            className={"w-full"}
            onRow={(record) => ({
              className: "cursor-pointer",
              onClick: () => {
                navigate(`/hrm/stationery-requests/${record.id}`);
              },
            })}
            scroll={{ x: 1200 }}
            columns={[
              {
                title: "Mã yêu cầu",
                dataIndex: "id",
                align: "center",
                width: 100,
              },

              {
                title: "Phòng ban",
                render: (_, record) => record.departmentName || "-",
              },
              {
                title: "Ngày tạo",
                dataIndex: "createdAt",
                render: (val) => dayjs(val).format("DD/MM/YYYY HH:mm"),
              },
              {
                title: "Ghi chú",
                dataIndex: "note",
                render: (val) => val || "-",
              },
              {
                title: "Chi tiết",
                render: (_, record) => {
                  return (
                    <Button
                      type="link"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/hrm/stationery-requests/${record.id}`);
                      }}
                    >
                      Chi tiết
                    </Button>
                  );
                },
              },
            ]}
          />
        </Card>
      </Flex>
    </div>
  );
};

export default HrmStationeryRequest;
